import { Component } from "react";
import ImageComponent from "../utilities/ImageComponent";

interface ICategoryIconProps {
  category: any;
}

export default class CategoryIcon extends Component<ICategoryIconProps> {
  render() {
    const { category } = this.props;

    let iconHtml: React.ReactNode = null;

    if (category.icon_url) {
      iconHtml = (
        <ImageComponent
          style={{ width: "100%", height: "100%" }}
          src={category.icon_url}
          alt={`${category.category_name} Category Icon`}
        />
      );
    }

    return iconHtml;
  }
}
